import type { ReactNode } from 'react';

export const symbol_http: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M40-384v-192q0-10.4 7-17.2 7-6.8 17-6.8t17 6.8q7 6.8 7 17.2v61h115v-61q0-10.4 7-17.2 7-6.8 17-6.8t17 6.8q7 6.8 7 17.2v192q0 10.4-7 17.2-7 6.8-17 6.8t-17-6.8q-7-6.8-7-17.2v-83H88v83q0 10.4-7 17.2-7 6.8-17 6.8t-17-6.8q-7-6.8-7-17.2Zm313 0v-168h-56q-10.4 0-17.2-7-6.8-7-6.8-17t6.8-17q6.8-7 17.2-7h160q10.4 0 17.2 7 6.8 7 6.8 17t-6.8 17q-6.8 7-17.2 7h-56v168q0 10.4-7 17.2-7 6.8-17 6.8t-17-6.8q-7-6.8-7-17.2Zm230 0v-168h-56q-10.4 0-17.2-7-6.8-7-6.8-17t6.8-17q6.8-7 17.2-7h160q10.4 0 17.2 7 6.8 7 6.8 17t-6.8 17q-6.8 7-17.2 7h-56v168q0 10.4-7 17.2-7 6.8-17 6.8t-17-6.8q-7-6.8-7-17.2Zm150 0v-194q0-9 7-15.5t16-6.5h115q23 0 36 13t13 36v58q0 23-13 35.5T871-445h-90v61q0 10.4-7 17.2-7 6.8-17 6.8t-17-6.8q-7-6.8-7-17.2Zm48-109h91v-59h-91v59Z"
		/>
	</svg>
);
